import React, { useMemo } from "react";
import cls from "./style.module.scss";
import useStyles from "isomorphic-style-loader/useStyles";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { FormattedMessage, useIntl } from "react-intl";
import AutoWidthSwiper from "../../../../../../components/swiper/autowidth";
import { useState } from "react";
import { useCallback } from "react";
import moment from "moment";

const CardGrade = props =>{
    const { levelItem, userLevel, progress, expiredDescription, expiredTime } = props;
    const [showExpired, setShowExpired] = useState(false);
    const [showCondition, setShowCondition] = useState(false);

    const showProgress = useMemo(()=>{
        return levelItem?.level == userLevel;
    }, [levelItem, userLevel])
    
    const showExpiredData = useMemo(() =>{
        return levelItem?.level <= userLevel;
    }, [levelItem, userLevel]);

    const speedValue = useMemo(() =>{
        if(progress?.speed >= 0){
            return Math.round(progress.speed * 100).toFixed(1)
        }
    }, [progress]);

    const expiredEvent = useCallback(() =>{
        setShowExpired(true);

        setTimeout(() =>{
            setShowExpired(false);
        },3000);
    }, []);

    const conditionEvent = useCallback(() =>{
        setShowCondition(true);

        setTimeout(() =>{
            setShowCondition(false);
        }, 3000)
    }, []);

    const getExpiredTime = useMemo(() =>{
        if(expiredTime){
            return moment(expiredTime).format('YYYY-MM-DD')
        }
    }, [expiredTime])

    return <div className={cls.CardGradeContainer}>
        <div className={cls.CardGrade} style={{backgroundImage: `url(${levelItem?.cardImageURL})`}}>
            {
                showExpiredData && expiredTime && <span className={cls.ExpiredTime}>
                    <span><FormattedMessage id="expired_in" defaultMessage="Expired in" /> {getExpiredTime}</span>
                    <Iconfont className={cls.Icon} onClick={expiredEvent}>&#xe718;</Iconfont>

                    {
                        showExpired && expiredDescription && <div className={cls.ExpiredMessage}>
                            {expiredDescription}
                        </div>
                    }
                    
                </span>
            }

            {
                showProgress && progress && Object.keys(progress).length > 0 && <div className={cls.VipLevelCondition}>
                    <div className={cls.Condition}>
                        <span>({progress.title})</span>
                        <Iconfont onClick={conditionEvent} className={cls.Icon}>&#xe718;</Iconfont>

                        {
                            showCondition && <React.Fragment>
                                <div className={cls.ConditionMessage}>
                                    {progress.description}
                                </div>

                                <span className={cls.ConditionJt}></span>
                            </React.Fragment>
                        }
                    </div>
                    
                    <div className={cls.Progress}>
                        <span>
                            <span style={{width:`${speedValue}%`}}></span>
                        </span>
                    </div>

                    <div className={cls.Level}>
                        <div>V{levelItem.level}</div>
                        <div>V{levelItem.level+1}</div>
                    </div>
                </div>
            }
            
            <div className={cls.ViewRules}>
                <a href="/policy/vip-policy"><FormattedMessage id="view_rules" defaultMessage="View Rules" />{'>'}</a>
            </div>
        </div>
    </div>
}

const CardGradeSwiper = props =>{
    const { vipStyles, userLevel, changeCurrentLevel } = props;

    const handleChange = (swiper) =>{
        changeCurrentLevel(swiper?.activeIndex)
    }

    return <div className={cls.CardGradeSwiper}>
        <AutoWidthSwiper
            items={vipStyles}
            options={{
                slidesPerView:'auto',
                centeredSlides: true,
                spaceBetween : 14,
                initialSlide: userLevel,
                onSlideChange:handleChange
            }}
            render={(item, index) =>{
                return <React.Fragment>
                    <CardGrade 
                        key={item.level+index} 
                        levelItem={item} 
                        {...props}
                    />
                </React.Fragment>
            }}
        />
    </div>
}

const GradeProcess = props =>{
    const { currentLevel, vipStyles, themeColor } = props;

    const tranFormNum = useMemo(() =>{
        return currentLevel * 50;
    }, [currentLevel]);

    return <div className={cls.GradeProcess}>
        <div className={cls.DirectLine}>
            <div></div>
        </div>

        <div className={cls.NumGrade} style={{transform: `translate(-${tranFormNum}px,-50%)`}}>
            <div className={cls.NumContainer}>
                {
                    vipStyles?.map((levelItem, index) =>(
                        <div className={`${cls.NumMainItem} ${currentLevel===index?cls.Active:""}`} key={levelItem.level+index}>
                            <div className={cls.Item} style={{color:themeColor[index]}}>V{levelItem.level}</div>
                        </div>
                    ))
                    
                }
            </div>
        </div>
    </div>
}

const VipName = props =>{
    useStyles(cls);
    const { customer } = props;
    const Intl = useIntl();

    const disposeName = useMemo(() =>{
        if(customer?.nickname){
            return customer.nickname;
        }else if(customer?.name?.firstName || customer?.name?.lastName){
            return `${customer.name?.firstName || ""} ${customer.name?.lastName || ""}`
        }else if(customer?.email){
            return customer.email
        }else if(customer?.phoneNumber){
            return customer.phoneNumber || Intl.formatMessage({id:"login_or_register", defaultMessage:"Sign In/Register"});
        }
    }, [customer]);

    return <div className={cls.VipName}>
        <span className={cls.Name}>{ disposeName }</span>
        <Iconfont>&#xe70e;</Iconfont>
    </div>
}

export default props =>{
    useStyles(cls);
    const { customer, vipStyles, currentLevel, themeColor, vipData, changeCurrentLevel, userLevel } = props;

    return <div className={cls.VipGrade}>
        <VipName customer={customer} />

        <GradeProcess 
            currentLevel={currentLevel} 
            themeColor={themeColor} 
            vipStyles={vipStyles} 
        />

        <CardGradeSwiper 
            vipStyles={vipStyles}  
            userLevel={userLevel} 
            progress={vipData?.progress} 
            expiredDescription={vipData?.expiredDescription}
            expiredTime={vipData?.expiredDate}
            changeCurrentLevel={changeCurrentLevel}
        />
    </div>
}